import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	refinementInvalidOptionMessage: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-option-message',
		defaultMessage: 'Your project and {refinement} selection is invalid.',
		description:
			'The text displayed when you hover over an invalid selected option in the refinement bar dropdown',
	},
	refinementInvalidProjectOptionMessage: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-project-option-message',
		defaultMessage: 'Your project selection is invalid.',
		description:
			'The text displayed when you hover over an invalid selected project in the refinement bar dropdown',
	},
});
